import { SectionHeader } from "./SectionHeader";
import type { Theme } from "./theme";

const ROWS: [string, string][] = [
  ["External dependency", "Internal capability"],
  ["Same sourcing channels", "Structured market approach"],
  ["Inconsistent assessment", "Consistent evaluation"],
  ["High fees", "Greater cost control"],
  ["No retained learning", "Reusable internal knowledge"],
];

export function AgencyTable({ theme }: { theme: Theme }) {
  return (
    <section
      style={{
        padding: "120px 0",
        borderTop: `1px solid ${theme.border}`,
        background: theme.surface,
      }}
    >
      <SectionHeader
        theme={theme}
        kicker="Agency positioning"
        title="Why organisations are rethinking agency-led hiring."
      >
        Use agencies where they add value — not as a default. With the right structure and alignment
        in place, more hiring can be handled internally, decision quality improves, and external
        partners can be used more selectively.
      </SectionHeader>
      <div style={{ maxWidth: 1000, margin: "0 auto", padding: "0 40px" }}>
        <div
          style={{
            border: `1px solid ${theme.border}`,
            borderRadius: theme.radius * 1.5,
            background: theme.bg,
            overflow: "hidden",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              padding: "16px 24px",
              borderBottom: `1px solid ${theme.border}`,
              background: theme.surface,
            }}
          >
            <div
              style={{
                fontSize: 12,
                letterSpacing: 0.5,
                textTransform: "uppercase",
                color: theme.fgMute,
              }}
            >
              Agency-led hiring
            </div>
            <div
              style={{
                fontSize: 12,
                letterSpacing: 0.5,
                textTransform: "uppercase",
                color: theme.accentFg,
                fontWeight: 500,
              }}
            >
              With Rarion
            </div>
          </div>
          {ROWS.map((r, i) => (
            <div
              key={r[0]}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                padding: "18px 24px",
                borderBottom: i < ROWS.length - 1 ? `1px solid ${theme.border}` : "none",
              }}
            >
              <div style={{ fontSize: 15, color: theme.fgMute }}>{r[0]}</div>
              <div style={{ fontSize: 15, color: theme.fg, fontWeight: 500 }}>{r[1]}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
